import React, { useState } from 'react'
import { HeaderSettingStyles } from './Style'
import { surferHooks } from '.'
import { LightButton } from 'styles/GlobalStyle'
import { keyBy } from 'lodash'

const HeaderSettings = (props) => {
    const { actionBtns, rate = 1 } = props
    const rateBtns = surferHooks.useRateBtns()
    const rateBtnKeys = keyBy(rateBtns, "id")

    const [selectedBtn, setSelectedBtn] = useState(rateBtnKeys[rate].id)

    return (
        <HeaderSettingStyles>
            <div className='rate-btns'>
                {rateBtns.map((btn) => {
                    const { id, action, markSelected } = btn

                    const handleClick = () => {
                        if (markSelected)
                            setSelectedBtn(id)
                        action()
                    }

                    return (
                        <LightButton
                            {...btn}
                            className="solid-round"
                            size="small"
                            variant={selectedBtn === id ? null : "solid2"}
                            label={`X ${btn.label}`}
                            selected={selectedBtn === id}
                            action={handleClick}
                            key={id}
                        />
                    )
                })}
            </div>
            {/* <div className='update-assessment'>
                {actionBtns?.map((btn) =>
                    <LightButton size="small" {...btn} />
                )}
            </div> */}
        </HeaderSettingStyles>
    )
}

export default HeaderSettings